module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-box"
  }, [_c('el-row', [_c('p', {}, [_vm._v("\n      " + _vm._s(_vm.data.label) + "\n    ")])]), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticStyle: {
      "--el-switch-on-color": "#13ce66",
      "--el-switch-off-color": "#ff4949"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), (_vm.data.model) ? _c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.companyDataRetention.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    class: _vm.verifyFields(_vm.data.companyDataRetention, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "multiple": "",
      "disabled": _vm.disabled,
      "multiple-limit": 2,
      "placeholder": _vm.data.companyDataRetention.placeholder,
      "required": _vm.data.companyDataRetention.required
    },
    on: {
      "change": function($event) {
        return _vm.generateAliquotOptions(_vm.data.companyDataRetention.model)
      },
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companyDataRetention.model, _vm.data.companyDataRetention.name)
      }
    },
    model: {
      value: (_vm.data.companyDataRetention.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companyDataRetention, "model", $$v)
      },
      expression: "data.companyDataRetention.model"
    }
  }, _vm._l((_vm.data.companyDataRetention.optionValue), function(option) {
    return _c('el-option', {
      key: option.idRetentionRegime,
      attrs: {
        "label": option.retentionRegime,
        "value": option.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [(_vm.verifyFields(_vm.data.companyDataRetention, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companyDataRetention.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.model) ? _c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.companyRetentionFields.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    class: _vm.verifyFields(_vm.data.companyRetentionFields, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.data.companyRetentionFields.placeholder,
      "required": _vm.data.companyRetentionFields.required
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companyRetentionFields.model, _vm.data.companyRetentionFields.name)
      }
    },
    model: {
      value: (_vm.data.companyRetentionFields.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companyRetentionFields, "model", $$v)
      },
      expression: "data.companyRetentionFields.model"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-option', {
      key: option.idCategoryRetain,
      attrs: {
        "label": option.categoryRetain,
        "value": option.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [(_vm.verifyFields(_vm.data.companyRetentionFields, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companyRetentionFields.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.data.companyDataRetention.model.includes('Retención Detracciones') && _vm.data.model)) ? _c('p', [_vm._v("Suspensión")]) : _vm._e(), _vm._v(" "), ((_vm.data.companyDataRetention.model.includes('Retención Detracciones') && _vm.data.model)) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.data.companySuspensionNumber.label
    }
  }, [_c('el-input', {
    class: _vm.verifyFields(_vm.data.companySuspensionNumber, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.data.companySuspensionNumber.type
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companySuspensionNumber.model, _vm.data.companySuspensionNumber.name)
      }
    },
    model: {
      value: (_vm.data.companySuspensionNumber.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companySuspensionNumber, "model", $$v)
      },
      expression: "data.companySuspensionNumber.model"
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data.companySuspensionNumber, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    staticStyle: {
      "margin-left": "34%",
      "margin-top": "-20px",
      "margin-bottom": "10px"
    },
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companySuspensionNumber.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-date-picker', {
    class: _vm.verifyFields(_vm.data.firstDate, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "2.5%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.firstDate.model, _vm.data.firstDate.name)
      }
    },
    model: {
      value: (_vm.data.firstDate.model),
      callback: function($$v) {
        _vm.$set(_vm.data.firstDate, "model", $$v)
      },
      expression: "data.firstDate.model"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    class: _vm.verifyFields(_vm.data.lastDate, _vm.validation) ? 'input-warning' : '',
    attrs: {
      "disabled": _vm.disabled,
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Hasta",
      "picker-options": _vm.disabledDates
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.lastDate.model, _vm.data.lastDate.name)
      }
    },
    model: {
      value: (_vm.data.lastDate.model),
      callback: function($$v) {
        _vm.$set(_vm.data.lastDate, "model", $$v)
      },
      expression: "data.lastDate.model"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('pdf-file', {
    attrs: {
      "disabled": _vm.disabled,
      "pdfFilePath": _vm.data.pdfSuspension.model,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": _vm.data.pdfSuspension.label,
      "id": _vm.data.pdfSuspension.label,
      "prop": _vm.data.pdfSuspension.name,
      "country": 'PER'
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.data.pdfSuspension, "model", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.data.pdfSuspension, "model", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data.pdfSuspension, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "title": ("Falta completar: " + (_vm.data.pdfSuspension.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd925f4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/SwitchRetention.vue
// module id = 661
// module chunks = 1